// Règle commune aux tableaux SuiviProd : un client n'apparaît qu'à partir de
// l'année de sa date de début de mission (champ Client.dateDebutMission).
// Date absente ou vide → comportement historique, visible sur toutes les années.
export const missionCommencee = (client, annee) =>
  !client?.dateDebutMission ||
  Number(annee) >= new Date(client.dateDebutMission).getFullYear();

// Symétrique de missionCommencee pour la borne de fin : un client archivé
// reste visible sur les années strictement antérieures à sa date d'effet, et
// disparaît dès l'année de cette date d'effet (Client.archiveDate) incluse.
// Pas archivé, ou pas de date d'effet renseignée → toujours visible
// (comportement historique inchangé).
export const missionActive = (client, annee) =>
  client?.status !== "Archivé" ||
  !client?.archiveDate ||
  Number(annee) < new Date(client.archiveDate).getFullYear();

// Dossier bloqué (litige de recouvrement, statut "Bloqué") : sa ligne est
// grisée avec un badge rouge dans les suivis (classe ligne-bloquee, voir
// Suivi.css et BadgeBloque.js) et il n'est pas compté dans les KPI.
export const estBloque = (client) => client?.status === "Bloqué";
export const classeLigneBloquee = (client) =>
  estBloque(client) ? "ligne-bloquee" : "";

// Une ligne "contact de l'Annuaire" (Suivi IR / TNS) est bloquée quand le
// contact a au moins un dossier lié et que TOUS ses dossiers sont bloqués.
export const contactBloque = (annuaire) =>
  (annuaire?.clients?.length || 0) > 0 && annuaire.clients.every(estBloque);

// Année AGO par défaut — source unique partagée entre SuiviJuridiqueAGO.js
// (selectedYear initial) et Bureau.jsx (KPI "AGO restant à faire"), pour que
// les deux restent toujours sur le même exercice sans mise à jour manuelle
// à deux endroits.
export const DEFAULT_AGO_YEAR = 2025;

// Les 5 missions Suivi Compta d'un client pour un mois/année donnés, dans
// l'ordre d'affichage — partagé entre SuiviCompta.js (grille) et l'ouverture
// de l'overlay Bouclage depuis SuiviTraitementsComptables.js (voir liaison
// Traitements comptables <-> Suivi Compta). Une mission absente du client
// (pas encore commencée) revient sous forme de placeholder non fait.
export const COMPTA_TASK_ORDER = [
  "Arrive PC",
  "Tri et numérisation",
  "Traitement niv.2",
  "Traitement niv.1",
  "Bouclage mensuel",
];

export function buildMonthTasks(client, month, year) {
  if (!client || !month) return [];

  const mois = client.Compta?.[0]?.mois.find(
    (m) => m.numero === month && m.annee === year
  );

  return COMPTA_TASK_ORDER.map((type, idx) => {
    const t = mois?.taches?.find((task) => task.type === type);
    return (
      t || {
        id: `${client.id}-${month}-${year}-${idx}`,
        type,
        statut: false,
      }
    );
  });
}
